import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.XeroAmaxPayBatchPaymentForm', {
    headerText: 'Batch Payment',
    batchPaymentBillsQty: 'Batch Payment bills: {qty}',
    addBills: 'Add Bills',
    removeAllBills: 'Remove all Bills',
    checkPaymentDetails: 'Check payment details',
    addBillsAttentionText: '200 bills are displayed at one time.',
});
